import { render, staticRenderFns } from "./InitiateProcess.vue?vue&type=template&id=28f11600&scoped=true&"
import script from "./InitiateProcess.vue?vue&type=script&lang=js&"
export * from "./InitiateProcess.vue?vue&type=script&lang=js&"
import style0 from "./InitiateProcess.vue?vue&type=style&index=0&id=28f11600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f11600",
  null
  
)

export default component.exports